import {
    CREATE_IRONING_PACKING_DC_FAILURE,
    CREATE_IRONING_PACKING_DC_REQUEST,
    CREATE_IRONING_PACKING_DC_SUCCESS,
    CREATE_USER_FORM_IRONING_PACKING_DC,
    FETCH_SINGLE_IRONING_PACKING_DC_FAILURE,
    FETCH_SINGLE_IRONING_PACKING_DC_REQUEST,
    FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS,
    FETCH_IRONING_PACKING_DC_FAILURE,
    FETCH_IRONING_PACKING_DC_REQUEST,
    FETCH_IRONING_PACKING_DC_SUCCESS,
    NAVIGATE_IRONING_PACKING_DC_DETAILS,
    NAVIGATE_IRONING_PACKING_DC,
    IRONING_PACKING_DC_USERFORM_RESET,
    UPDATE_IRONING_PACKING_DC_FAILURE,
    UPDATE_IRONING_PACKING_DC_REQUEST,
    UPDATE_IRONING_PACKING_DC_SUCCESS,
    DELETE_IRONING_PACKING_DC_REQUEST,
    DELETE_IRONING_PACKING_DC_SUCCESS,
    DELETE_IRONING_PACKING_DC_FAILURE,
    IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_IRONING_PACKING_DC_STYLE_REQUEST,
    FETCH_IRONING_PACKING_DC_STYLE_SUCCESS,
    FETCH_IRONING_PACKING_DC_STYLE_FAILURE,
    FETCH_IRONING_PACKING_DC_INVOICE_REQUEST,
    FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS,
    FETCH_IRONING_PACKING_DC_INVOICE_FAILURE,
    RESET_IRONING_PACKING_DC_INVOICE,
    NAVIGATE_IRONING_WITH_ACC_INITIAL,
    NAVIGATE_IRONING_WITH_ACC,
    NAVIGATE_IRONING_WITH_ACC_LAST,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_IRONING_PACKING_DC_PRINT
} from './ironingPackingDC.actionsType';

export const IRONING_PACKING_DC = 'ironingPackingDc';

let initialState = {
    loading: false,
    ironingPackingDC: [],
    ironingPackingDCInvoice: [],
    ironingPackingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: true,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedIroningPackingDC: {},
    detailsId: '',
    activeKey: 1,
    isIroningPackingDC: false,
    ironingPackingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    detailTextVar: 'details',
    activeKeyDetail: '1',
    headerSearchCall: true,
};

export let ironingPackingDcReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_IRONING_PACKING_DC_REQUEST:
        case FETCH_IRONING_PACKING_DC_INVOICE_REQUEST:
        case FETCH_IRONING_PACKING_DC_STYLE_REQUEST:
        case CREATE_IRONING_PACKING_DC_REQUEST:
        case FETCH_SINGLE_IRONING_PACKING_DC_REQUEST:
        case UPDATE_IRONING_PACKING_DC_REQUEST:
        case DELETE_IRONING_PACKING_DC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDC: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCInvoice: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCStyle: updatePayload?.PONO
            };
        case CREATE_IRONING_PACKING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case UPDATE_IRONING_PACKING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_IRONING_PACKING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedIroningPackingDC: {}
            };
        case FETCH_IRONING_PACKING_DC_FAILURE:
        case FETCH_IRONING_PACKING_DC_INVOICE_FAILURE:
        case FETCH_IRONING_PACKING_DC_STYLE_FAILURE:
        case FETCH_SINGLE_IRONING_PACKING_DC_FAILURE:
        case CREATE_IRONING_PACKING_DC_FAILURE:
        case UPDATE_IRONING_PACKING_DC_FAILURE:
        case DELETE_IRONING_PACKING_DC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_IRONING_PACKING_DC_INVOICE:
            return {
                ...state,
                ironingPackingDCInvoice: []
            };
        case IRONING_PACKING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedIroningPackingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_IRONING_PACKING_DC_DETAILS:
            return {
                ...state,
                isIroningPackingDC: true,
                detailTextVar: payload,
                ironingPackingDCSelectedValue: updatePayload.ironingPackingDCSelectedValue
            };
        case NAVIGATE_IRONING_PACKING_DC:
            return {
                ...state,
                isIroningPackingDC: false,
                detailTextVar: 'details',
            };
        case NAVIGATE_IRONING_PACKING_DC_PRINT:
            return {
                ...state,
                isIroningPackingDC: false,
                ironingPackingDCSelectedValue: updatePayload.ironingPackingDCSelectedValue
            };

        case IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        case NAVIGATE_IRONING_WITH_ACC_INITIAL:
            return {
                ...state,
                activeKeyDetail: '1'
            }
        case NAVIGATE_IRONING_WITH_ACC:
            return {
                ...state,
                loading: false,
                activeKeyDetail: '2'
            }
        case NAVIGATE_IRONING_WITH_ACC_LAST:
            return {
                ...state,
                loading: false,
                activeKeyDetail: '3'
            }
        default:
            return state;
    }
};
